<template>
  <div v-if="list">
    <div class="main-layout__list main-layout__list_mxh80">
      <div
        class="main-layout__item main-layout__item_hover main-layout__item_head main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">
          <p>#</p>
        </div>

        <div class="w-10">
          <span>{{$t('listsHeader.skillName')}}</span>
        </div>

        <div class="main-layout__item-actions">
          <p>{{$t('listsHeader.actions')}}</p>
        </div>
      </div>

      <div
        class="main-layout__item main-layout__item_hover main-layout__item_mh"
        v-for="(item, index) in list"
        :key="item.id"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="w-3 t-c">
          <p>{{ index + 1 }}</p>
        </div>

        <div class="w-10">
          <span>{{ item.name }}</span>
        </div>

        <div class="main-layout__item-actions">
          <div>
            <svg
              v-if="$guard('write', 'Tags')"
              @click="editSkill(item)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div>
            <svg
              @click="openDeleteModal(item.id)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <div>
            <delete-request
              v-if="$guard('delete', 'Tags') && item.deletion_tag"
              :item="item"
              :type="'skills'"
              @save="fetch"
              @remove="openDeleteModal"
            />
          </div>
        </div>
      </div>
    </div>

    <add-btn v-if="$guard('write', 'Tags')" @onClick="openModalAdapter" />

    <modal :show="isShow" :dark="true" :outside="false" @close="closeModal">
      <skills-modal :isUpdate="updatedId" @close="closeModal" @done="saveSkill" />
    </modal>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import skillsModal from '@/components/modals/skills/skillsModal'
import deleteRequest from '@/components/controls/deleteRequest'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    components: { addBtn, skillsModal, deleteRequest },
    data() {
        return {
            isShow: false,
            isShowDeleteModal: false,
            isAdding: true,
            updatedId: null,
            deletedId: null,
        }
    },
    computed: {
        ...mapGetters({
            list: 'skills/list',
        }),
    },
    methods: {
        ...mapActions({
            requestForDelete: 'deleteControl/requestForDelete',
            fetch: 'skills/fetch',
            add: 'skills/add',
            update: 'skills/update',
            remove: 'skills/remove',
        }),
        ...mapMutations({
            setState: 'skills/setState',
        }),
        editSkill(item) {
            this.isAdding = false
            this.setState({
                key: 'skill',
                data: {
                    name: item.name,
                },
            })
            this.updatedId = item.id
            this.openModal()
        },
        openModalAdapter() {
            this.isAdding = true
            this.openModal()
        },
        openModal() {
            this.isShow = true
        },
        closeModal() {
            this.isShow = false
            this.updatedId = null
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
        async deleteConfirm() {
            try {
                if (!this.$guard('delete', 'Tags')) {
                    await this.requestForDelete({
                        id: this.deletedId,
                        type: 'skills',
                    })
                    await this.fetch()

                    this.closeDeleteModal()
                    return
                }

                const response = await this.remove(this.deletedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeDeleteModal()
            } catch {
                // error
            }
        },
        async saveSkill() {
            if (this.isAdding) {
                const response = await this.add()
                const isOkey = response.status === 201

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            } else {
                const response = await this.update(this.updatedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            }
        },
        openDeleteAdapter() {},
    },
}
</script>
